import { Component, Input } from '@angular/core';

@Component({
  selector: 'am-banner-dollar',
  styleUrls: ['./banner-dollar.component.scss'],
  templateUrl: './banner-dollar.component.html',
})
export class BannerDollarComponent {
  @Input() public isMobile = false;
  constructor() {}
}
